import Nullstack from 'nullstack';
export default function IconSortAscendingLetters({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-sort-ascending-letters",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M15 10v-5c0 -1.38 .62 -2 2 -2s2 .62 2 2v5m0 -3h-4"
  }), "   ", Nullstack.element("path", {
    d: "M19 21h-4l4 -7h-4"
  }), "   ", Nullstack.element("path", {
    d: "M4 15l3 3l3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M7 6v12"
  }), " ");
}